import add from "date-fns/add";
import format from "date-fns/format"

export default function tomorrow() {
  return format(add(new Date(), {
    days: 1,
  }), 'yyyy-MM-dd');
}
